import React from 'react';
import { twMerge } from 'tailwind-merge';
import { getAppPath } from '../../../../util/ProxyPath';
export var LogoContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, sizeClasses = _a.sizeClasses, iconPath = _a.iconPath;
    return (React.createElement("div", { className: twMerge('rounded-full border border-solid border-gray-100 bg-white shadow', className, sizeClasses) },
        React.createElement("img", { src: getAppPath(iconPath), alt: "partner logo", className: sizeClasses })));
};
export default LogoContainer;
